module.exports = __webpack_public_path__ + "media/images/emblems/SantAntonino-coat_of_arms-f9b07108d2052d06041f36018345dedd.svg";